export class PDropDownModel {
    name: string;
    value: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/primeng/PDropDownModel.ts